
// Copy of the website's built-in product page tabs content (aavryaa_frontend
// Constants/productTabsContent.js). The Product Page Tabs editor shows these as
// the original values; only fields that differ are saved.
export const PRODUCT_TABS_DEFAULTS = {
  descTab: "Description",

  showEstimator: true,
  estimatorFor: "all", // "all" products, or "fabrics" (sold by the metre) only
  estimatorTab: "Fabric Estimator",
  estimatorText: "Confused about how much fabric you need? Use our estimator!",
  estimatorButton: "View Estimator",
  estimatorTitle: "Fabric Estimator",
  estimatorImage: "", // one picture for the pop-up; empty = the two original guides
  estimatorNote: "According to your measurement designs, then depends on the flare fabric estimation will vary. For further queries regarding customization, please feel free to call us at 9789389489. We are always ready to assist you. Thank you!",
  estimatorNoteBold: "9789389489",

  showShipping: true,
  shippingTab: "Shipping",
  shippingTitle: "Pan India Delivery",
  shippingText: "We ship across India with care and speed. Orders above ₹999 get free shipping.",
  shippingImage: "", // optional picture under the shipping info (none by default)

  showWashcare: true,
  washcareTab: "Washcare",
  washcareTitle: "Wash Care Instructions",
  washcareImage: "", // optional picture, e.g. a wash-symbols chart (none by default)
  washcareTips: [
      "Dry clean recommended for designer wear, embellished outfits, and premium fabrics.",
      "Hand wash separately in cold water for cotton and printed fabrics.",
      "Do not soak for long periods.",
      "Use mild detergents only. Avoid bleach and harsh chemicals.",
      "Wash dark and light colors separately to prevent color transfer.",
      "Do not wring or twist delicate fabrics.",
      "Dry in shade and avoid direct sunlight to preserve colors and prints.",
      "Iron on low to medium heat as per fabric type.",
      "Steam ironing is recommended for delicate and embroidered garments.",
      "Store garments in a cool, dry place away from moisture.",
      "For heavily embellished, handworked, or customized pieces, professional dry cleaning is advised."
  ],
  washcareLink: "Read full wash care guide →",
};

// Maximum lengths — keep in step with the backend (routes/siteContentRoutes.js)
export const PRODUCT_TABS_LIMITS = {
  descTab: 28, estimatorTab: 28, estimatorText: 200, estimatorButton: 28, estimatorTitle: 40,
  estimatorNote: 500, estimatorNoteBold: 60,
  shippingTab: 28, shippingTitle: 50, shippingText: 300,
  washcareTab: 28, washcareTitle: 50, washcareTips: { items: 15, each: 200 }, washcareLink: 50,
};
